import { createFileRoute } from '@tanstack/react-router'
import { StaffPertanahan } from '../../../../components/StaffPertanahan'

export const Route = createFileRoute('/desa/$slug/dashboard/pertanahan')({
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    if (!desaId) return null
    return <StaffPertanahan desaId={desaId} />
  },
})
